package com.anjuros.website.templates.template9.modules

import com.anjuros.website.templates.template9.util.ResKey
import com.anjuros.website.templates.template9.util.Template9Res

enum class Template9Review(
    val review: ResKey,
    val reviewer: ResKey,
    val image: String
) {
    Review1(
        review = ResKey.TEMPLATE9_REVIEW1,
        reviewer = ResKey.TEMPLATE9_REVIEW1_NAME,
        image = Template9Res.Image.review1
    ),
    Review2(
        review = ResKey.TEMPLATE9_REVIEW2,
        reviewer = ResKey.TEMPLATE9_REVIEW2_NAME,
        image = Template9Res.Image.review2
    ),
    Review3(
        review = ResKey.TEMPLATE9_REVIEW3,
        reviewer = ResKey.TEMPLATE9_REVIEW3_NAME,
        image = Template9Res.Image.review3
    )
}
